import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Container, Input, Label, Row, Button, Form, FormFeedback, Alert, Spinner } from 'reactstrap';
import ParticlesAuth from "./ParticlesAuth";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
import * as Yup from "yup";
import { useFormik } from "formik";
import { loginUser, resetLoginFlag } from "../../slices/thunks";
import { createSelector } from 'reselect';
import LoginImg from "../../assets/images/Login.png";

const Login = (props) => {
    const dispatch = useDispatch();

    const selectLayoutState = (state) => state;
    const loginpageData = createSelector(
        selectLayoutState,
        (state) => ({
            user: state.Account.user,
            error: state.Login.error,
            loading: state.Login.loading,
            errorMsg: state.Login.errorMsg,
        })
    );
    const { user, error, loading, errorMsg } = useSelector(loginpageData);

    const [userLogin, setUserLogin] = useState([]);
    const [passwordShow, setPasswordShow] = useState(false);

    useEffect(() => {
        if (user) {
            const updatedUserData = process.env.REACT_APP_DEFAULTAUTH === "firebase" ? user.multiFactor.user.email : user.user.email;
            const updatedUserPassword = process.env.REACT_APP_DEFAULTAUTH === "firebase" ? "" : user.user.confirm_password;
            setUserLogin({ email: updatedUserData, password: updatedUserPassword });
        }
    }, [user]);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            email: userLogin.email || "",
            password: userLogin.password || "",
        },
        validationSchema: Yup.object({
            email: Yup.string().required("Please Enter Your Email"),
            password: Yup.string().required("Please Enter Your Password"),
        }),
        onSubmit: (values) => {
            dispatch(loginUser(values, props.router.navigate));
        },
    });

    useEffect(() => {
        if (errorMsg) {
            setTimeout(() => { dispatch(resetLoginFlag()); }, 3000);
        }
    }, [dispatch, errorMsg]);

    document.title = "Sign In | SOC Platform";

    return (
        <React.Fragment>
            <ParticlesAuth>
                <div
                    className="auth-page-content d-flex align-items-center"
                    style={{
                        minHeight: "100vh",
                        // Deep background matching the darkest part of your image
                        background: "radial-gradient(circle, #150605 0%, #0b0101 100%)",
                    }}
                >
                    <Container fluid>
                        <Row className="justify-content-center align-items-center">
                            
                            {/* Left: Illustration */}
                            <Col md={5} lg={6} className="text-center d-none d-md-block">
                                <img
                                    src={LoginImg}
                                    alt="Security Illustration"
                                    className="img-fluid"
                                    style={{
                                        maxHeight: "90vh",
                                        marginLeft: "-40px",
                                        filter: "drop-shadow(0 0 30px rgba(212, 93, 0, 0.15))"
                                    }}
                                />
                            </Col>

                            {/* Right: Login Panel */}
                            <Col md={7} lg={5} xl={4}>
                                <Card
                                    className="mt-4 border-0 shadow-lg"
                                    style={{
                                        // Dark reddish-brown translucent background
                                        backgroundColor: "rgba(21, 6, 5, 0.92)", 
                                        color: "#fff",
                                        borderRadius: "12px",
                                        minWidth: "380px", 
                                        border: "1px solid rgba(212, 93, 0, 0.1)"
                                    }}
                                >
                                    <CardBody className="p-5">
                                        <div className="text-center mt-2">
                                            <h4 className="text-white fw-bold">🔐 Secure Login</h4>
                                            <p style={{ color: "#a88a7a", fontSize: "0.9rem" }}>Access your PULSE Dashboard</p>
                                        </div>

                                        {error && <Alert color="danger" className="mt-3"> {error} </Alert>}

                                        <div className="p-2 mt-4">
                                            <Form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); }}>
                                                
                                                <div className="mb-4">
                                                    <Label className="form-label text-white-50">Email</Label>
                                                    <Input
                                                        name="email"
                                                        placeholder="Enter email"
                                                        type="email"
                                                        className="bg-transparent text-white"
                                                        style={{
                                                            border: "1px solid #3d2b2a",
                                                            backgroundColor: "#110404"
                                                        }}
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.email}
                                                        invalid={validation.touched.email && !!validation.errors.email}
                                                    />
                                                    {validation.touched.email && validation.errors.email && (
                                                        <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                                                    )}
                                                </div>

                                                <div className="mb-4">
                                                    <div className="float-end">
                                                        <Link to="/forgot-password" style={{ color: "#d45d00", fontSize: "0.85rem" }}>
                                                            Forgot password?
                                                        </Link>
                                                    </div>
                                                    <Label className="form-label text-white-50">Password</Label>
                                                    <div className="position-relative auth-pass-inputgroup">
                                                        <Input
                                                            name="password"
                                                            value={validation.values.password}
                                                            type={passwordShow ? "text" : "password"}
                                                            className="bg-transparent text-white pe-5"
                                                            style={{
                                                                border: "1px solid #3d2b2a",
                                                                backgroundColor: "#110404"
                                                            }}
                                                            placeholder="Enter Password"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            invalid={validation.touched.password && !!validation.errors.password}
                                                        />
                                                        <button
                                                            className="btn btn-link position-absolute end-0 top-0 text-muted"
                                                            type="button"
                                                            onClick={() => setPasswordShow(!passwordShow)}
                                                        >
                                                            <i className="ri-eye-fill"></i>
                                                        </button>
                                                        {validation.touched.password && validation.errors.password && (
                                                            <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="form-check mb-4">
                                                    <Input className="form-check-input" type="checkbox" id="auth-remember-check" />
                                                    <Label className="form-check-label text-white-50" htmlFor="auth-remember-check">
                                                        Remember me
                                                    </Label>
                                                </div>

                                                <div className="mt-4">
                                                    <Button
                                                        className="w-100 border-0 fw-bold"
                                                        style={{
                                                            // The specific orange/amber from your background image
                                                            backgroundColor: "#d45d00",
                                                            color: "#fff",
                                                            padding: "10px",
                                                            boxShadow: "0 4px 15px rgba(212, 93, 0, 0.25)"
                                                        }}
                                                        type="submit"
                                                        disabled={loading}
                                                    >
                                                        {loading ? <Spinner size="sm" className="me-2" /> : "Sign In"}
                                                    </Button>
                                                </div>

                                            </Form>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </ParticlesAuth>
        </React.Fragment>
    );
};

export default withRouter(Login);